const checkYaVideoLink = (link: string | undefined) => {
  if (!link) return false
  return link.includes('yandex.net')
}

const getYaVideoId = (url: string) => {
  const regex = /\/[^/]+\/([a-zA-Z0-9]+)(?:\?|$)/
  const match = url.match(regex)
  return match ? match[1] : null
}

const translationHiddenControlsList = `
  play,
  contextMenu,
  live,
  mobileSeekButtons,
  playbackRate,
  poster,
  preloader,
  settings,
  startScreen,
  startScreenPlay,
  subtitlesToggle,
  timeline,
  timelinePreview,
  time,
  title,`

export { checkYaVideoLink, getYaVideoId, translationHiddenControlsList }
